export const hotSearches = [
  '年度盛典红毯',
  '热门综艺换人',
  '剧组花絮',
  '网络热梗盘点',
  '明星童年照',
  '巡演门票秒罄',
  '选角内幕',
  '粉丝接机现场',
];

export const siteInfo = {
  name: '51吃瓜网',
  slogan: '今日吃瓜，一站到齐',
  intro:
    '51吃瓜网是聚焦娱乐圈热点新闻、爆料报道和网络趣闻的资讯平台。我们以实时更新为原则，为用户提供快速、清晰、便于分享的娱乐动态浏览体验。平台内容涵盖明星动向、影视与综艺资讯、圈内爆料线索以及网络热梗趣闻，帮助你在碎片时间里轻松掌握今日吃瓜重点。',
  scope:
    '内容范围包括娱乐行业公开资讯、作品动态、活动现场报道与网络公开讨论话题。所有内容均用于资讯展示与交流，不涉及个人隐私信息，也不构成任何投资或消费建议。',
  contact: {
    email: 'hello@51chigua.com',
    weibo: '@51吃瓜网',
    wechat: 'chigua51',
  },
  disclaimer:
    '本站为资讯演示平台，部分内容由网络公开信息整理，仅供参考。如涉及内容版权或事实更正，请通过上方联系方式与我们联系，我们将在核实后及时处理。',
};